(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-campari-v2"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var sectionId = '{{ section.id }}';
      var newsletterForm = document.getElementById('CampariNewsletterForm-' + sectionId);
      var submitButton = document.getElementById('NewsletterSubmit-' + sectionId);

      if (!newsletterForm) {
        return;
      }

      newsletterForm.addEventListener('submit', function () {
        newsletterForm.classList.add('is-submitting');
        if (submitButton) {
          submitButton.setAttribute('disabled', 'disabled');
        }
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
